type AvailabilityTypes = { id: string; appointmentTypeIds: string[] }

/**
 * Standard mode books a provider for the union of their availabilities' appointment types, so the
 * UI edits that union as one set. Saving applies only the change to each record: added types go
 * onto every record and removed types come off every record, so per-chair choices that Advanced
 * mode would use again are kept. A record left with no types takes the whole new set, because the
 * API rejects an availability without one.
 */
export function planStandardModeTypeUpdates(
  availabilities: AvailabilityTypes[],
  initialTypeIds: string[],
  nextTypeIds: string[],
): AvailabilityTypes[] {
  const added = nextTypeIds.filter((id) => !initialTypeIds.includes(id))
  const removed = new Set(initialTypeIds.filter((id) => !nextTypeIds.includes(id)))

  return availabilities.flatMap((availability) => {
    const kept = availability.appointmentTypeIds.filter((id) => !removed.has(id))
    const merged = [...kept, ...added.filter((id) => !kept.includes(id))]
    const appointmentTypeIds = merged.length ? merged : nextTypeIds
    const unchanged =
      appointmentTypeIds.length === availability.appointmentTypeIds.length &&
      appointmentTypeIds.every((id) => availability.appointmentTypeIds.includes(id))
    return unchanged ? [] : [{ id: availability.id, appointmentTypeIds }]
  })
}
